var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"speech-bubbles"},_vm._l((_vm.data),function(bubble){return _c('DraggableSpeechBubble',{key:bubble.id,attrs:{"data":bubble,"type":_vm.type,"order":_vm.getOrder(Number(bubble.index)),"draggable-parts":_vm.draggableGapsSentenceParts(bubble)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }